/**
 * Error wrapper that tags a caught fetch error with the originating query
 * stage. Preserves the underlying cause without mutating it, so frozen or
 * shared error instances are not modified in place. The tagged `queryType`
 * is surfaced through the consuming feature's `onError` callback and resolved
 * by `formatAsyncErrorBodyText` so the fallback UI can render a
 * query-specific message.
 */
class BatchQueryError extends Error {
  constructor(queryType, cause) {
    super(cause?.message);
    this.name = 'BatchQueryError';
    this.queryType = queryType;
    this.cause = cause;
  }
}

export default BatchQueryError;
